import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export class AppValidators {
  static readonly PHONE_REGEX = /^[0-9-.+\s\(\)]*$/
  static readonly PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{4,}$/
  static readonly LOGIN_REGEX = '^[0-9a-z_\\-+@.]+$';

  static validateWithoutPattern(pattern: string): ValidatorFn {
    const regex = new RegExp(pattern);
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && regex.test(control.value)) {
        return { withoutPattern: true };
      }
      return null;
    };
  }

  static validateEquals(controlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const matchingControl = control.parent?.get(controlName);
      if (matchingControl && control.value !== matchingControl.value) {
        return { notEqual: true };
      }
      return null;
    }
  }

  /**
   * Reverse validator for {@link AppValidators.validateEquals}
   * 
   * Returns null always, but triggers re-validation of the matching control.
   * Shall be used on the "confirm" control to ensure it is re-validated when
   * the original control changes.
   * 
   * @param controlName Name of the control to re-validate (e.g. the password confirmation control)
   * @returns ValidationErrors | null
   */
  static validateEqualsReverse(controlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const reverseMatchingControl = control.parent?.get(controlName);
      reverseMatchingControl?.updateValueAndValidity()
      return null;
    }
  }
}